import React, { ReactNode } from 'react';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import 'styles/app.scss';
import rootStore from './RootStore';
import { isCurrentBrowserSupported } from 'utils/browserUtils';
import { GQToastContainer } from 'components/GQToast/GQToastContainer';
import { E_TOAST_TYPE } from 'components/GQToast/GQToast';
import { FGThemeProvider } from '@fg/design-system';
import Router from 'Router';
import { PiwikRouteTracker } from 'components/PiwikRouteTracker';
import('./services/lib/WebSocketService');

const isBrowserSupported = isCurrentBrowserSupported();
let toaster: GQToastContainer;

const AppProvider = React.memo(({ children }: { children: ReactNode }) => {
    return (
        <div style={{ height: '100%' }}>
            <FGThemeProvider
                mode="dark"
                appendThemeTo={
                    typeof document !== 'undefined' ? document.body : undefined
                }>
                <Provider {...rootStore}>
                    <HashRouter
                        future={{
                            // https://reactrouter.com/6.30.0/upgrading/future#v7_starttransition
                            v7_startTransition: true,
                        }}>
                        <PiwikRouteTracker />
                        {children}
                    </HashRouter>
                </Provider>
            </FGThemeProvider>
        </div>
    );
});

const App = React.memo(() => {
    return <Router />;
});

if (!isBrowserSupported && toaster) {
    toaster.createToast(
        'Your browser is not supported. Please use Chrome to avoid unexpected behaviour and errors.',
        {
            type: E_TOAST_TYPE.ERROR,
            autoClose: false,
        }
    );
}

export default function AppContainer() {
    return (
        <AppProvider>
            <App />
        </AppProvider>
    );
}
